<template>
  <div id="adminCrmConnections">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">booking</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Connessioni</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin"> 
        <h1>Connessioni</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewConnections"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableConnectionsConfiguration"
                  :datas="tableData"
                  id="tableConnections"
                  :onCheck="onTableCheckConnections"
                  :onCheckAll="onTableCheckConnections"
                  :onUncheck="onTableCheckConnections"
                  :onUncheckAll="onTableCheckConnections"
                  ref="tableConnections"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-body" style="padding:30px;">
              <div class="row">
                <div class="col-6">
                <pageDetail
                  functions="adminCrmConnections"
                  :configurations="DetailConnectionsConfiguration"
                  :jsonValue="detailData"
                ></pageDetail>
                </div>
                 <div class="col-6">
                <label for="description" class="labelclass">Descrizione:</label>
                <textarea id="description" class="form-control" name="description" rows="9" cols="50">
                </textarea>
                </div>
              </div>
            <!--section date -->
              <div class="row" style="margin-top: 20px;">
                <div class="col-2"><label class="labelclass" for="huey">Data Fissa</label>
                </div>
                <div class="col-3"><label class="labelclass" for="huey">Intervallo di date</label></div>

              </div>

        <div class="row">
                <div class="col-2">
                  <div class="row">
                    <div class="col-1">
                    <input type="radio" class="radio" id="check_fixed_date" name="check_fixed_date" @change="clickCheckFixedDate()"></div>
                    <div class="col-8">
                  <!-- <input type="fixed_date" class="form-control" id="fixed_date" required="required" name="fixed_date" placeholder="Data"/> -->
                  <date-picker
                        placeholder="Data"
                        class="classinput"
                        required="required"
                        id="fixed_date"
                        name="fixed_date"
                        :config="configDateTime"
                  ></date-picker>
                   </div>
                  </div>
                </div>
              <div class="col-4"> 
                  <div class="row">
                      <div class="col-1"> 
                      <input type="radio" class="radio" id="check_datefrom_and_dateto" name="check_datefrom_and_dateto" @change="clickCheckDateFromAndDateTo()">
                      </div>
                  <div class="col-4">                   
                    <!--<input
                              type="date_from"
                              class="form-control"
                              id="date_from"
                              required="required"
                              name="date_from"
                              placeholder="Dal"
                            />-->
                  <date-picker
                        placeholder="Dal"
                        class="classinput"
                        required="required"
                        id="date_from"
                        name="date_from"
                        :config="configDateTime"
                  ></date-picker>
                  </div>
                  <div class="col-4"> 
                             <!-- <input
                                type="date_to"
                                class="form-control"
                                id="date_to"
                                required="required"
                                name="date_to"
                                placeholder="Al"
                              />--->
                  <date-picker
                        placeholder="Al"
                        required="required"
                        id="date_to"
                        class="classinput"
                        name="date_to"
                        :config="configDateTime"
                  ></date-picker>
                  </div>
                     <div class="col-3" id="btn-add-time">
                       <i
                            class="fa fa-plus-circle"
                            style="font-size: 22px;cursor:pointer;"
                            id="add-time-agg"
                            @click="addTimePlus"
                          ></i>Aggiungi ore/posti</div>
                </div>
              </div>

               <div class="col-6 text-right">
                <div id="div-cont-options"></div>
                <h3 style="font-size: 20px;font-weight: lighter; color: rgb(48, 60, 84);">Aggiungi Opzioni</h3>
                          <i
                            class="fa fa-plus-circle"
                            style="font-size: 22px; cursor: pointer;"
                            id="add-img-agg"
                            @click="addOptionList"
                          ></i>  
              </div>
            
              <!--- <div class="col-6 text-right">
                 <div class="row">
                    <div class="col-6">
                        <div id="div-cont-options"></div>
                      </div>
                          <h3 style="font-size: 20px;font-weight: lighter; color: rgb(48, 60, 84);">Aggiungi Opzioni</h3>
                          <i
                            class="fa fa-plus-circle"
                            style="font-size: 22px; cursor: pointer;"
                            id="add-img-agg"
                            @click="addOptionList"
                          ></i>
                </div></div> --->
             <!--  <div class="col-12">
                   <div class="row" style="margin-top:20px;">
                    <div class="col-1" id="label_monday"><label class="labelclass" for="louie">Lun</label></div>
                    <div class="col-1" id="label_tuesday"><label class="labelclass" for="louie">Mar</label></div>
                    <div class="col-1" id="label_wednesday"><label class="labelclass" for="louie">Mer</label></div>
                    <div class="col-1" id="label_thursday"><label class="labelclass" for="louie">Gio</label></div>
                    <div class="col-1" id="label_friday"><label class="labelclass" for="louie">Ven</label></div>
                    <div class="col-1" id="label_saturday"><label class="labelclass" for="louie">Sab</label></div>
                    <div class="col-1" id="label_sunday"><label class="labelclass" for="louie">Dom</label></div>
                     <div class="col-3" id="label_exclude_holidays"><label class="labelclass" for="louie" style="white-space: nowrap;">Escludi Festivi</label></div>
              </div>
                </div> --->
                 <div class="col-9">
                   <div class="row" style="margin-top: 10px;">
                      <!-- <div class="col-2"><input type="radio" id="check_repetition" name="check_repetition" @change="clickCheckRepetition()"></div> -->
                     <div class="col-1" id="div_monday">
                         <label class="labelclass" for="louie">Lun</label>
                       <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="monday"
                          name="monday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label></div>                  
                      <div class="col-1" id="div_tuesday">
                       <label class="labelclass" for="louie">Mar</label>
                        <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="tuesday"
                          name="tuesday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label></div>                 
                      <div class="col-1" id="div_wednesday">
                        <label class="labelclass" for="louie">Mer</label>
                        <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="wednesday"
                          name="wednesday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label></div>                   
                      <div class="col-1" id="div_thursday">
                        <label class="labelclass" for="louie">Gio</label>
                        <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="thursday"
                          name="thursday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label></div>                    
                     <div class="col-1" id="div_friday">
                       <label class="labelclass" for="louie">Ven</label>
                       <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="friday"
                          name="friday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label>
                        </div>                
                      <div class="col-1" id="div_saturday">
                        <label class="labelclass" for="louie">Sab</label>
                        <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="saturday"
                          name="saturday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label>
                      </div>                    
                     <div class="col-1" id="div_sunday"> 
                       <label class="labelclass" for="louie">Dom</label>
                       <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="sunday"
                          name="sunday"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label>
                     </div>
                     <div class="col-1" id="div_exclude_holidays">
                       <label class="labelclass" for="louie">Escludi Festivi</label>
                      <label
                        class="switch switch-pill switch-primary"
                        style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          class="switch-input"
                          id="exclude_holidays"
                          name="exclude_holidays"
                        />
                        <span class="switch-slider" data-on data-off></span>
                      </label>
                     </div>  
                    
                </div>
                 </div>
                 </div>


 <div class="row" id = "oraridatafissa" style="margin-top: 2px;">
<div class="col-6">
                  <div class="row">
                    <div class="col-3">
                    <label class="labelclass">Ora di inizio AM</label><br>
                     <vue-timepicker format="HH:mm" id="start_time"></vue-timepicker>
                    </div>
                    <div class="col-3">
                    <label class="labelclass">Ora di fine AM</label><br>
                       <vue-timepicker format="HH:mm" id="end_time"></vue-timepicker>
                   </div>
                    <div class="col-3">
                    <label class="labelclass">Ora di inizio PM</label><br>
                     <vue-timepicker format="HH:mm" id="start_time_pm"></vue-timepicker>
                              </div>
                    <div class="col-3">
                    <label class="labelclass">Ora di fine PM</label><br>
                       <vue-timepicker format="HH:mm" id="end_time_pm"></vue-timepicker>
                   </div>
                  </div>
                </div>
                 <div class="col-6" style="margin-top:-5px;">
                  <pageDetail
                        functions="adminCrmConnections"
                        :configurations="DetailConnections2Configuration"
                        :jsonValue="detailData"
                ></pageDetail>
                 </div>
                 </div>
     
    <div class="col-9">   
        <div class="row">  
 <div id="div-cont-add-time-agg"></div>
</div></div>



                 <div class="row">
                   <div class="col-6">
                  <pageDetail
                        functions="adminCrmConnections"
                        :configurations="DetailConnections3Configuration"
                        :jsonValue="detailData"
                ></pageDetail> 
              </div> 
              </div>
        <!--end section date -->

              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewConnections"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                   @click="confirmSaveNewConnections"
                  ><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                 <!--  <button
                    type="button"
                    class="btn btn-success"
                   @click="confirmAperturaViewDettaglioData"
                  ><i class="fa fa-floppy-o"></i>&nbsp; Cerca Ore Disponibili</button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminCrmConnections",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
    VueTimepicker
  },

  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      registries: dictionaryHelpers.getDictionary("registries"),
      Employees: "Addetti",
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      DetailConnectionsConfiguration: [],
      cont: 0,
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newTitleConnections: "Nuovo",
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
      id: 0,
      languagePageSetting: { content: null }
      },
      configDateTime: {
        format: storageData.sDatePickerFormat(),
        useCurrent: true,
        showClear: true,
        showClose: true,
      },
      TableConnectionsConfiguration: [],
      DetailConnections2Configuration: [],
      DetailConnections3Configuration: [],
      tableCustomerResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmConnections = this;
    
    spinnerHelpers.show();
    this.languages = storageData.sIdLanguage();

    adminCrmConnections.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

        adminConfigurationServices.getFunctionality(function(result) {
        adminCrmConnections.TableConnectionsConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
        adminCrmConnections.DetailConnectionsConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
        adminCrmConnections.DetailConnections2Configuration = result.data.tabsConfigurations[1].pageConfigurations; 
        adminCrmConnections.DetailConnections3Configuration = result.data.tabsConfigurations[2].pageConfigurations; 
        adminCrmConnections.loadTable();
    });
  },



  methods: {
    loadTable(ln) {
      var adminCrmConnections = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      connectionsServices.getAll(ln,function(result) {
        adminCrmConnections.tableData = result.data;
        spinnerHelpers.hide();
      });

    },

     languageChange(value) {
      spinnerHelpers.show();
      var adminCrmConnections = this;
      this.languages = value;
      adminCrmConnections.loadTable(value);
      spinnerHelpers.hide();
    },

   
  ConnectionsFormatter(value, row, index, field) {
      var adminCrmConnections = this;
      var html =
        '<div class="container-fluid nopadding" style="min-width:80px;">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmConnections.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
         html +=
        '<button class="btn btn-info" onclick="adminCrmConnections.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';
          html +=
        '<button class="btn btn-danger" onclick="adminCrmConnections.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmConnections.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div>";
      return html;
    },

     executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmConnections = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
          if (adminCrmConnections.rowIdSelected == row.id) {        
              adminCrmConnections.detailData = row;
             // console.log(row);
              $("#fixed_date").val(row.fixed_date);
              $("#date_from").val(row.date_from);
              $("#date_to").val(row.date_to);
              $("#start_time").val(row.start_time);
              $("#end_time").val(row.end_time);
              $("#start_time_pm").val(row.start_time_pm);
              $("#end_time_pm").val(row.end_time_pm);
              $("#description").val(row.description);

            if (row.check_datefrom_and_dateto == 2) {    
                $('input[name="check_datefrom_and_dateto"]').prop('checked', true);
                  $("#div_monday").hide();
                  $("#div_tuesday").hide();
                  $("#div_wednesday").hide();
                  $("#div_thursday").hide();
                  $("#div_friday").hide();
                  $("#div_saturday").hide();
                  $("#div_sunday").hide();
                  $("#div_exclude_holidays").hide();
                  $("#label_monday").hide();
                  $("#label_tuesday").hide();
                  $("#label_wednesday").hide();
                  $("#label_thursday").hide();
                  $("#label_friday").hide();
                  $("#label_saturday").hide();
                  $("#label_sunday").hide();
                  $("#start_time").hide();
                  $("#end_time").hide();
                  $("#start_time_pm").hide();
                  $("#end_time_pm").hide();
                  $("#nr_place").hide();
                  $("#show_availability_calendar").hide();
                  $("#oraridatafissa").hide();

            }else{
                $('input[name="check_datefrom_and_dateto"]').prop('checked', false);
            }

            if (row.check_fixed_date == 1) {    
                  $('input[name="check_fixed_date"]').prop('checked', true);
                
            }else{
                $('input[name="check_fixed_date"]').prop('checked', false); 
            }
            /*if (row.check_repetition == 3) {    
                $('input[name="check_repetition"]').prop('checked', true);
                $("#div_monday").show();
                $("#div_tuesday").show();
                $("#div_wednesday").show();
                $("#div_thursday").show();
                $("#div_friday").show();
                $("#div_saturday").show();
                $("#div_sunday").show();
                $("#div_exclude_holidays").show();
                $("#label_monday").show();
                $("#label_tuesday").show();
                $("#label_wednesday").show();
                $("#label_thursday").show();
                $("#label_friday").show();
                $("#label_saturday").show();
                $("#label_sunday").show();
                $("#label_exclude_holidays").show();
            }else{
                $('input[name="check_repetition"]').prop('checked', false);
                  $("#div_monday").hide();
                  $("#div_tuesday").hide();
                  $("#div_wednesday").hide();
                  $("#div_thursday").hide();
                  $("#div_friday").hide();
                  $("#div_saturday").hide();
                  $("#div_sunday").hide();
                  $("#div_exclude_holidays").hide();
                  $("#label_monday").hide();
                  $("#label_tuesday").hide();
                  $("#label_wednesday").hide();
                  $("#label_thursday").hide();
                  $("#label_friday").hide();
                  $("#label_saturday").hide();
                  $("#label_sunday").hide();
                  $("#label_exclude_holidays").hide();
            }*/

            if (row.monday == true) {    
                $('input[name="monday"]').prop('checked', true);
            }else{
                $('input[name="monday"]').prop('checked', false);
            }
            if (row.tuesday == true) {    
                $('input[name="tuesday"]').prop('checked', true);
            }else{
                $('input[name="tuesday"]').prop('checked', false);
            }
            if (row.wednesday == true) {    
                $('input[name="wednesday"]').prop('checked', true);
            }else{
                $('input[name="wednesday"]').prop('checked', false);
            }
            if (row.thursday == true) {    
                $('input[name="thursday"]').prop('checked', true);
            }else{
                $('input[name="thursday"]').prop('checked', false);
            }
            if (row.friday == true) {    
                $('input[name="friday"]').prop('checked', true);
            }else{
                $('input[name="friday"]').prop('checked', false);
            }
            if (row.saturday == true) {    
                $('input[name="saturday"]').prop('checked', true);
            }else{
                $('input[name="saturday"]').prop('checked', false);
            }
            if (row.sunday == true) {    
                $('input[name="sunday"]').prop('checked', true);
            }else{
                $('input[name="sunday"]').prop('checked', false);
            }
            if (row.exclude_holidays == true) {    
                $('input[name="exclude_holidays"]').prop('checked', true);
            }else{
                $('input[name="exclude_holidays"]').prop('checked', false);
            }
            //console.log(row.listOptions);
            var AggOptions = row.listOptions;
          if (AggOptions.length > 0) {
                  adminCrmConnections.cont = AggOptions.length;
                  $("#div-cont-options").html("");
                  for (var j = 0; j < AggOptions.length; j++) {
                    var html = "";
                    if (j < 10) {
                html += '<div class="row" style="margin-bottom: 10px;margin-top: -15px;" data-id-row="' + adminCrmConnections.cont + '" id="divcont-' + adminCrmConnections.cont + '" >';
                html += '<div class="col-6 text-left">';
                html += '<label class="labelclass">Opzioni</label><br>';
                html += '<input type="hidden" style="min-height: 56px" class="form-control" id="id' + j + '" value="' + AggOptions[j].id + '" name="id' + j + '">';
                html += '<select class="custom-select optional_id_select" style="min-height: 56px;" id="optional_id' + j + '" value="' + AggOptions[j].optional_id + '" name="optional_id' + j + '"></select>';
               // html += '<input type="text" style="min-height: 56px" class="form-control options" id="options' + j + '" value="' + AggOptions[j].options + '" name="options' + j + '">';
                html += "</div>";
                html += '<div class="col-2 text-left">';
                html += '<label class="labelclass">Costo</label>';
                html += '<input type="text" style="min-height: 56px" class="form-control cost" id="cost' + j + '" value="' + AggOptions[j].cost + '" name="cost' + j + '">';
                html += "</div>";
                html += '<div class="col-2 text-left">';
                html += '<label class="labelclass">Cadauno</label>';
                if (AggOptions[j].check_each == true){
                html += '<label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox" class="switch-input" id="check_each' + j + '" value="' + AggOptions[j].check_each + '" name="check_each' + j + '" checked="checked' + j + '"><span class="switch-slider" data-on data-off></span></label>';
                }else {
                html += '<label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox" class="switch-input" id="check_each' + j + '" value="' + AggOptions[j].check_each + '" name="check_each' + j + '"><span class="switch-slider" data-on data-off></span></label>';
                }
                html += "</div>";
                html += '<div class="col-2">';
                html += '<button type="button" style="margin-top: 30px;" class="btn btn-outline-danger del-img-agg" data-id-cont="' + adminCrmConnections.cont + '" id="btndelete' + adminCrmConnections.cont + '"><i class="fa fa-times"></i></button>'
                html += "</div>";
                html += "</div>";
                $("#div-cont-options").append(html);
              }

           var searchParam = "";
           var initials = [];
            initials.push({
            id: AggOptions[j].optional_id,
            text: AggOptions[j].options,
          }); 
          $('#optional_id' + j).select2({
            data: initials,
            ajax: {
              url: configData.wsRootServicesUrl + '/api/v1/typeoptional/select',
              data: function (params) {
                if (params.term == '') {
                  searchParam = '*';
                } else {
                  searchParam = params.term;
                }
                var query = {
                  search: searchParam,
                }
                return query;
              },
              processResults: function (data) {
                var dataParse = JSON.parse(data);
                return {
                  results: dataParse.data
                };
              }
            }
          });
                  }
      }

                $("#div-cont-options .del-img-agg").on("click", function(e) {
                var idDel = $(this).attr('data-id-cont');
                var el = $(this).parent('div').parent('div').attr('data-id-img-agg', idDel);
                adminCrmConnections.cont = adminCrmConnections.cont - 1;
                if(adminCrmConnections.cont < 0){
                  adminCrmConnections.cont = 0;
                }
                el.remove();
              });

        /* section book */
        
          var AggDetailAddDayHour = row.DetailAddDayHour;

          if (AggDetailAddDayHour.length > 0) {
                  adminCrmConnections.cont = AggDetailAddDayHour.length;
                  $("#div-cont-add-time-agg").html("");
                  for (var j = 0; j < AggDetailAddDayHour.length; j++) {
                  var html = "";
                  if (j < 10) {   
                  html += '<div class="row" style="margin-bottom: 26px;margin-top: 20px;" data-id-row="' + adminCrmConnections.cont + '" id="divcont-' + adminCrmConnections.cont + '" >';
                  html += '<div class="col-1">';
                  if (AggDetailAddDayHour[j].monday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Lun</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="monday_agg' + j + '" value="' + AggDetailAddDayHour[j].monday_agg + '" name="monday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }else {
                  html +=
                    '<label class="labelclass" for="louie">Lun</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="monday_agg' + j + '" value="' + AggDetailAddDayHour[j].monday_agg + '" name="monday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";
                  html += '<div class="col-1">';
                   if (AggDetailAddDayHour[j].tuesday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Mar</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="tuesday_agg' + j + '" value="' + AggDetailAddDayHour[j].tuesday_agg + '" name="tuesday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                    }else {
                  html +=
                    '<label class="labelclass" for="louie">Mar</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="tuesday_agg' + j + '" value="' + AggDetailAddDayHour[j].tuesday_agg + '" name="tuesday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";
                  html += '<div class="col-1">';
                   if (AggDetailAddDayHour[j].wednesday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Mer</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="wednesday_agg' + j + '" value="' + AggDetailAddDayHour[j].wednesday_agg + '" name="wednesday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                   }else {
                      html +=
                    '<label class="labelclass" for="louie">Mer</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="wednesday_agg' + j + '" value="' + AggDetailAddDayHour[j].wednesday_agg + '" name="wednesday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'  
                   }
                  html += "</div>";
                  html += '<div class="col-1">';

                  if (AggDetailAddDayHour[j].thursday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Gio</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="thursday_agg' + j + '" value="' + AggDetailAddDayHour[j].thursday_agg + '" name="thursday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }else {
                  html +=
                    '<label class="labelclass" for="louie">Gio</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="thursday_agg' + j + '" value="' + AggDetailAddDayHour[j].thursday_agg + '" name="thursday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";
                  html += '<div class="col-1">';
                  if (AggDetailAddDayHour[j].friday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Ven</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="friday_agg' + j + '" value="' + AggDetailAddDayHour[j].friday_agg + '" name="friday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                   }else {
                     html +=
                    '<label class="labelclass" for="louie">Ven</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="friday_agg' + j + '" value="' + AggDetailAddDayHour[j].friday_agg + '" name="friday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>' 
                   }
                  html += "</div>";
                  html += '<div class="col-1">';
                  if (AggDetailAddDayHour[j].saturday_agg == true){
                  html +=
                    '<label class="labelclass" for="louie">Sab</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="saturday_agg' + j + '" value="' + AggDetailAddDayHour[j].saturday_agg + '" name="saturday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }else {
                   html +=
                    '<label class="labelclass" for="louie">Sab</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="saturday_agg' + j + '" value="' + AggDetailAddDayHour[j].saturday_agg + '" name="saturday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";
                  html += '<div class="col-1">';
                 if (AggDetailAddDayHour[j].sunday_agg == true){ 
                  html +=
                    '<label class="labelclass" for="louie">Dom</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="sunday_agg' + j + '" value="' + AggDetailAddDayHour[j].sunday_agg + '" name="sunday_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }else {
                    html +=
                    '<label class="labelclass" for="louie">Dom</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="sunday_agg' + j + '" value="' + AggDetailAddDayHour[j].sunday_agg + '" name="sunday_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>' 
                  }
                  html += "</div>";
                  html += '<div class="col-1">';
                  if (AggDetailAddDayHour[j].exclude_holidays_agg == true){ 
                  html +=
                    '<label class="labelclass" for="louie">Escludi Festivi</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;vertical-align: bottom"><input type="checkbox" class="switch-input" id="exclude_holidays_agg' + j + '" value="' + AggDetailAddDayHour[j].exclude_holidays_agg + '" name="exclude_holidays_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                   }else {
                    html +=
                    '<label class="labelclass" for="louie">Escludi Festivi</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;vertical-align: bottom"><input type="checkbox" class="switch-input" id="exclude_holidays_agg' + j + '" value="' + AggDetailAddDayHour[j].exclude_holidays_agg + '" name="exclude_holidays_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>' 
                   }     
                  html += "</div>";
                  html += "</div>";


              
                  html += '<div class="row"  style="margin-bottom: 26px;margin-top: -10px;" data-id-row="' + adminCrmConnections.cont + '" id="divcont-' + adminCrmConnections.cont + '" >';
                  html += '<div class="col-6">';
                  html += '<div class="row"  style="margin-bottom: 26px;margin-top: -10px;" data-id-row="' + adminCrmConnections.cont + '" id="divcont-' + adminCrmConnections.cont + '" >';

                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Ora di inizio AM</label><input placeholder="HH:mm" type="text" class="form-controls" id="start_time_am_agg' + j + '" value="' + AggDetailAddDayHour[j].start_time_am_agg + '" name="start_time_am_agg' + j + '">';
                  html += "</div>";
                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Ora di fine AM</label><input placeholder="HH:mm" type="text" class="form-controls" id="end_time_am_agg' + j + '" value="' + AggDetailAddDayHour[j].end_time_am_agg + '" name="end_time_am_agg' + j + '">';
                  html += "</div>";
                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Ora di inizio PM</label><input placeholder="HH:mm" type="text" class="form-controls" id="start_time_pm_agg' + j + '" value="' + AggDetailAddDayHour[j].start_time_pm_agg + '" name="start_time_pm_agg' + j + '">';
                  html += "</div>";
                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Ora di fine PM</label><input placeholder="HH:mm" type="text" class="form-controls" id="end_time_pm_agg' + j + '" value="' + AggDetailAddDayHour[j].end_time_pm_agg + '" name="end_time_pm_agg' + j + '">';
                  html += "</div>";
              
                  html += "</div>"; 
                  html += "</div>";

                  html += '<div class="col-6">';
                  html += '<div class="row"  style="margin-bottom: 26px;margin-top: -10px;" data-id-row="' + adminCrmConnections.cont + '" id="divcont-' + adminCrmConnections.cont + '" >';
                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Posti</label><input type="text" placeholder="Posti" class="form-controls" id="nr_place_agg' + j + '" value="' + AggDetailAddDayHour[j].nr_place_agg + '" name="nr_place_agg' + j + '">';
                  html += "</div>";

                  html += '<div class="col-3">';
                   if (AggDetailAddDayHour[j].show_availability_calendar_agg == true){ 
                  html += '<label class="labelclass" for="louie">Mostra disponibilità</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; margin-left: 17px!important;vertical-align: bottom"><input type="checkbox" class="switch-input" id="show_availability_calendar_agg' + j + '" value="' + AggDetailAddDayHour[j].show_availability_calendar_agg + '" name="show_availability_calendar_agg' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                   }else {
                  html += '<label class="labelclass" for="louie">Mostra disponibilità</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;margin-left: 17px!important; vertical-align: bottom"><input type="checkbox" class="switch-input" id="show_availability_calendar_agg' + j + '" value="' + AggDetailAddDayHour[j].show_availability_calendar_agg + '" name="show_availability_calendar_agg' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";


                  html += '<div class="col-3">';
                  if (AggDetailAddDayHour[j].limit_reservations == true){ 
                  html += '<label class="labelclass" for="louie">Limita Prenotazioni</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; margin-left: 17px!important;vertical-align: bottom"><input type="checkbox" class="switch-input" id="limit_reservations' + j + '" value="' + AggDetailAddDayHour[j].limit_reservations + '" name="limit_reservations' + j + '" checked="checked' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                   }else {
                  html += '<label class="labelclass" for="louie">Limita Prenotazioni</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;margin-left: 17px!important; vertical-align: bottom"><input type="checkbox" class="switch-input" id="limit_reservations' + j + '" value="' + AggDetailAddDayHour[j].limit_reservations + '" name="limit_reservations' + j + '"/><span class="switch-slider" data-on data-off></span></label>'
                  }
                  html += "</div>";

                  html += '<div class="col-3">';
                  html += '<label class="labelclass" for="input-limited-range">Minuti Prima dell\'evento</label><input type="text" placeholder="Minuti Prima dell\'evento" class="form-controls" id="hour' + j + '" value="' + AggDetailAddDayHour[j].hour + '" name="hour' + j + '">';
                  html += "</div>";

                  html += "</div>";
                  html += "</div>";
                  html += "</div>";

                  html += "<hr>";
                  $("#div-cont-add-time-agg").append(html);
                  }
          }
      }

        /* end section book */

          }

      });
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    clone(id) {
      var adminCrmConnections = this;
      var ln = adminCrmConnections.languages;
      spinnerHelpers.show();
      connectionsServices.clone(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmConnections.loadTable(ln);
      });
    },

    addTimePlus() {
    var adminCrmConnections = this; 
    var html="";

    if (adminCrmConnections.cont  < 10) {
        adminCrmConnections.cont = adminCrmConnections.cont + 1;


        html += '<div class="row" style="margin-bottom: 10px;margin-top: 20px;" id="divcont-'+ adminCrmConnections.cont + '" data-id-agg-time="' + adminCrmConnections.cont + '">';
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Lun</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="monday_agg' + adminCrmConnections.cont + '" name="monday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Mar</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="tuesday_agg' + adminCrmConnections.cont + '" name="tuesday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Mer</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="wednesday_agg' + adminCrmConnections.cont + '" name="wednesday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Gio</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="thursday_agg' + adminCrmConnections.cont + '" name="thursday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Ven</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="friday_agg' + adminCrmConnections.cont + '" name="friday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Sab</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="saturday_agg' + adminCrmConnections.cont + '" name="saturday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Dom</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="sunday_agg' + adminCrmConnections.cont + '" name="sunday_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-1">';
        html +=
           '<label class="labelclass" for="louie">Escludi Festivi</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"><input type="checkbox" class="switch-input" id="exclude_holidays_agg' + adminCrmConnections.cont + '" name="exclude_holidays_agg"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += "</div>";

        html += '<div class="row" style="margin-bottom: 26px;margin-top: -2px;" id="divcont-'+ adminCrmConnections.cont + '" data-id-agg-time="' + adminCrmConnections.cont + '">';

        html += '<div class="col-6">';
        html += '<div class="row" style="margin-bottom: 26px;margin-top: -2px;" id="divcont-'+ adminCrmConnections.cont + '" data-id-agg-time="' + adminCrmConnections.cont + '">';
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Ora di inizio AM</label><input placeholder="HH:mm" type="text" class="form-controls" id="start_time_am_agg' + adminCrmConnections.cont + '" name="start_time_am_agg' + adminCrmConnections.cont + '">';
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Ora di fine AM</label><input placeholder="HH:mm" type="text" class="form-controls" id="end_time_am_agg' + adminCrmConnections.cont + '" name="end_time_am_agg' + adminCrmConnections.cont + '">';
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Ora di inizio PM</label><input placeholder="HH:mm" type="text" class="form-controls" id="start_time_pm_agg' + adminCrmConnections.cont + '" name="start_time_pm_agg' + adminCrmConnections.cont + '">';
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Ora di fine PM</label><input placeholder="HH:mm" type="text" class="form-controls" id="end_time_pm_agg' + adminCrmConnections.cont + '" name="end_time_pm_agg' + adminCrmConnections.cont + '">';
        html += "</div>";
       
        html += "</div>";
        html += "</div>";


        html += '<div class="col-6">';
        html += '<div class="row" style="margin-bottom: 26px;margin-top: -2px;" id="divcont-'+ adminCrmConnections.cont + '" data-id-agg-time="' + adminCrmConnections.cont + '">';
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Posti</label><input type="text" placeholder="Posti" class="form-controls" id="nr_place_agg' + adminCrmConnections.cont + '" name="nr_place_agg' + adminCrmConnections.cont + '">';
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="louie">Mostra disponibilità</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;margin-left: 17px!important; vertical-align: bottom"><input type="checkbox" class="switch-input" id="show_availability_calendar_agg' + adminCrmConnections.cont + '" name="show_availability_calendar"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="louie">Limita Prenotazioni</label><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px;margin-left: 17px!important; vertical-align: bottom"><input type="checkbox" class="switch-input" id="limit_reservations' + adminCrmConnections.cont + '" name="limit_reservations"/><span class="switch-slider" data-on data-off></span></label>'
        html += "</div>";
        html += '<div class="col-3">';
        html += '<label class="labelclass" for="input-limited-range">Minuti prima dell\'evento</label><input type="text" placeholder="Minuti prima dell\'evento" class="form-controls" id="hour' + adminCrmConnections.cont + '" name="hour' + adminCrmConnections.cont + '">';
        html += "</div>";

        html += "</div>";
        html += "<hr>";
        html += "</div>"; 

        html += "</div>"; 
        $("#div-cont-add-time-agg").append(html);
    }
    },


    addOptionList() {
      var adminCrmConnections = this;
      var html = "";

    if (adminCrmConnections.cont  < 10) {
        adminCrmConnections.cont = adminCrmConnections.cont + 1;
        html += '<div class="row" style="margin-bottom: 10px;margin-top: -15px;" id="divcont-'+ adminCrmConnections.cont + '" data-id-img-agg="' + adminCrmConnections.cont + '">';
        html += '<div class="col-6 text-left">';
        html += '<label class="labelclass">Opzioni</label><br>';
        //html += '<input type="text" style="min-height: 56px" class="form-control options" id="options' + adminCrmConnections.cont + '" name="options' + adminCrmConnections.cont + '">';
        html += '<select class="custom-select optional_id_select" style="min-height: 56px;" id="optional_id' + adminCrmConnections.cont + '" value="' + adminCrmConnections.cont + '" name="optional_id' + adminCrmConnections.cont + '"></select>';
        html += "</div>";
        html += '<div class="col-2 text-left">';
        html += '<label class="labelclass">Costo</label>';
        html += '<input type="text" style="min-height: 56px" class="form-control cost" id="cost' + adminCrmConnections.cont + '" name="cost' + adminCrmConnections.cont + '">';
        html += "</div>";
        html += '<div class="col-2 text-left">';
        html += '<label class="labelclass">Cadauno</label>';
        html += '<label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox" class="switch-input" id="check_each" name="check_each" class="switch-input"' + adminCrmConnections.cont + '"><span class="switch-slider" data-on data-off></span></label>';
        html += "</div>";
        html += '<div class="col-2">';
       // html += '<i class="fa fa-times del-img-agg" data-id-cont="' + adminCrmConnections.cont + '"></i>';
        html += '<button type="button" style="margin-top: 30px;" class="btn btn-outline-danger del-img-agg" data-id-cont="' + adminCrmConnections.cont + '" id="btndelete' + adminCrmConnections.cont + '"><i class="fa fa-times"></i></button>'
        html += "</div>";
        html += "</div>";
        $("#div-cont-options").append(html);
    }

     $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function(){ 
        var searchParam = "";
        $('#optional_id' + adminCrmConnections.cont).select2({
          ajax: {
          url: configData.wsRootServicesUrl + '/api/v1/typeoptional/select',
          data: function (params) {
            if(params.term==''){
              searchParam = '*';
            }else{
            searchParam = params.term;
            }
            var query = {
            search: searchParam,
            }
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
            results: dataParse.data
            };
          }
          }
        }); 
      });

      $("#div-cont-options .del-img-agg").on("click", function(e) {
      var idDel = $(this).attr('data-id-cont');
      var el = $(this).parent('div').parent('div').attr('data-id-img-agg', idDel);
      adminCrmConnections.cont = adminCrmConnections.cont - 1;
      if(adminCrmConnections.cont < 0){
        adminCrmConnections.cont = 0;
      }
      el.remove();
    });
  },


    clickCheckFixedDate() {
    var adminCrmConnections = this; 

    var check_fixed_date = $("#check_fixed_date").val();

    if ($("#check_fixed_date").is(":checked")) {
          check_fixed_date = true;

          document.getElementById("fixed_date").disabled = false;
          
          $("#date_from").val("");
          $("#date_to").val("");
          $('input[name="check_repetition"]').prop('checked', false);
          $('input[name="check_datefrom_and_dateto"]').prop('checked', false);

          document.getElementById("monday").disabled = true;
          document.getElementById("tuesday").disabled = true;
          document.getElementById("wednesday").disabled = true;
          document.getElementById("thursday").disabled = true;
          document.getElementById("friday").disabled = true;
          document.getElementById("saturday").disabled = true;
          document.getElementById("sunday").disabled = true;
          document.getElementById("exclude_holidays").disabled = true;
          document.getElementById("date_from").disabled = true;
          document.getElementById("date_to").disabled = true;
          $('input[name="monday"]').prop('checked', false);
          $('input[name="tuesday"]').prop('checked', false);
          $('input[name="wednesday"]').prop('checked', false);
          $('input[name="thursday"]').prop('checked', false);
          $('input[name="friday"]').prop('checked', false);
          $('input[name="saturday"]').prop('checked', false);
          $('input[name="sunday"]').prop('checked', false);
          $('input[name="exclude_holidays"]').prop('checked', false);
              $("#div_monday").hide();
              $("#div_tuesday").hide();
              $("#div_wednesday").hide();
              $("#div_thursday").hide();
              $("#div_friday").hide();
              $("#div_saturday").hide();
              $("#div_sunday").hide();
              $("#div_exclude_holidays").hide();
              $("#label_monday").hide();
              $("#label_tuesday").hide();
              $("#label_wednesday").hide();
              $("#label_thursday").hide();
              $("#label_friday").hide();
              $("#label_saturday").hide();
              $("#label_sunday").hide();
              $("#label_exclude_holidays").hide();
              $("#btn-add-time").hide();  
          } else {
          check_fixed_date = false;
          document.getElementById("fixed_date").disabled = true;
          document.getElementById("monday").disabled = false;
          document.getElementById("tuesday").disabled = false;
          document.getElementById("wednesday").disabled = false;
          document.getElementById("thursday").disabled = false;
          document.getElementById("friday").disabled = false;
          document.getElementById("saturday").disabled = false;
          document.getElementById("sunday").disabled = false;
          document.getElementById("exclude_holidays").disabled = false;
          document.getElementById("date_from").disabled = false;
          document.getElementById("date_to").disabled = false;
        }
          this.detailData.check_fixed_date = $("#check_fixed_date").val();
    },

    clickCheckDateFromAndDateTo() {
      var adminCrmConnections = this;   
      var check_datefrom_and_dateto = $("#check_datefrom_and_dateto").val();
      
    if ($("#check_datefrom_and_dateto").is(":checked")) {
          check_datefrom_and_dateto = true;

          document.getElementById("date_from").disabled = false;
          document.getElementById("date_to").disabled = false;
          document.getElementById("fixed_date").disabled = true;

            $("#fixed_date").val("");
           /* $("#div_monday").show();
            $("#div_tuesday").show();
            $("#div_wednesday").show();
            $("#div_thursday").show();
            $("#div_friday").show();
            $("#div_saturday").show();
            $("#div_sunday").show();
            $("#div_exclude_holidays").show();
            $("#label_monday").show();
            $("#label_tuesday").show();
            $("#label_wednesday").show();
            $("#label_thursday").show();
            $("#label_friday").show();
            $("#label_saturday").show();
            $("#label_sunday").show();
            $("#label_exclude_holidays").show();*/
                  $("#div_monday").hide();
                  $("#div_tuesday").hide();
                  $("#div_wednesday").hide();
                  $("#div_thursday").hide();
                  $("#div_friday").hide();
                  $("#div_saturday").hide();
                  $("#div_sunday").hide();
                  $("#div_exclude_holidays").hide();
                  $("#label_monday").hide();
                  $("#label_tuesday").hide();
                  $("#label_wednesday").hide();
                  $("#label_thursday").hide();
                  $("#label_friday").hide();
                  $("#label_saturday").hide();
                  $("#label_sunday").hide();
                  $("#start_time").hide();
                  $("#end_time").hide();
                  $("#start_time_pm").hide();
                  $("#end_time_pm").hide();
                  $("#nr_place").hide();
                  $("#show_availability_calendar").hide();
                  $("#oraridatafissa").hide();
                  $("#btn-add-time").show();

          $('input[name="check_repetition"]').prop('checked', false);
          $('input[name="check_fixed_date"]').prop('checked', false);

          document.getElementById("monday").disabled = false;
          document.getElementById("tuesday").disabled = false;
          document.getElementById("wednesday").disabled = false;
          document.getElementById("thursday").disabled = false;
          document.getElementById("friday").disabled = false;
          document.getElementById("saturday").disabled = false;
          document.getElementById("sunday").disabled = false;
          document.getElementById("exclude_holidays").disabled = false;

          
          $('input[name="monday"]').prop('checked', false);
          $('input[name="tuesday"]').prop('checked', false);
          $('input[name="wednesday"]').prop('checked', false);
          $('input[name="thursday"]').prop('checked', false);
          $('input[name="friday"]').prop('checked', false);
          $('input[name="saturday"]').prop('checked', false);
          $('input[name="sunday"]').prop('checked', false);
          $('input[name="exclude_holidays"]').prop('checked', false);
              
        } else {
          check_datefrom_and_dateto = false;
          document.getElementById("date_from").disabled = true;
          document.getElementById("date_to").disabled = true;

              $("#div_monday").hide();
              $("#div_tuesday").hide();
              $("#div_wednesday").hide();
              $("#div_thursday").hide();
              $("#div_friday").hide();
              $("#div_saturday").hide();
              $("#div_sunday").hide();
              $("#div_exclude_holidays").hide();
              $("#label_monday").hide();
              $("#label_tuesday").hide();
              $("#label_wednesday").hide();
              $("#label_thursday").hide();
              $("#label_friday").hide();
              $("#label_saturday").hide();
              $("#label_sunday").hide();
              $("#label_exclude_holidays").hide();
              $("#btn-add-time").show();
          document.getElementById("monday").disabled = true;
          document.getElementById("tuesday").disabled = true;
          document.getElementById("wednesday").disabled = true;
          document.getElementById("thursday").disabled = true;
          document.getElementById("friday").disabled = true;
          document.getElementById("saturday").disabled = true;
          document.getElementById("sunday").disabled = true;
          document.getElementById("exclude_holidays").disabled = true;
          document.getElementById("fixed_date").disabled = true;      
        }
          this.detailData.check_datefrom_and_dateto = $("#check_datefrom_and_dateto").val();
        
    },

   /* clickCheckRepetition() {
      var adminCrmConnections = this;  
      var check_repetition = $("#check_repetition").val();

     if ($("#check_repetition").is(":checked")) {
          check_repetition = true;

          $('input[name="check_datefrom_and_dateto"]').prop('checked', false);
          $('input[name="check_fixed_date"]').prop('checked', false);
            $("#div_monday").show();
            $("#div_tuesday").show();
            $("#div_wednesday").show();
            $("#div_thursday").show();
            $("#div_friday").show();
            $("#div_saturday").show();
            $("#div_sunday").show();
            $("#div_exclude_holidays").show();
            $("#label_monday").show();
            $("#label_tuesday").show();
            $("#label_wednesday").show();
            $("#label_thursday").show();
            $("#label_friday").show();
            $("#label_saturday").show();
            $("#label_sunday").show();
            $("#label_exclude_holidays").show();

          document.getElementById("fixed_date").disabled = true;
          document.getElementById("date_from").disabled = true;
          document.getElementById("date_to").disabled = true;
          $("#fixed_date").val("");
          $("#date_from").val("");
          $("#date_to").val("");
          document.getElementById("monday").disabled = false;
          document.getElementById("tuesday").disabled = false;
          document.getElementById("wednesday").disabled = false;
          document.getElementById("thursday").disabled = false;
          document.getElementById("friday").disabled = false;
          document.getElementById("saturday").disabled = false;
          document.getElementById("sunday").disabled = false;
          document.getElementById("exclude_holidays").disabled = false; 

        } else {
          check_repetition = false;
              $("#div_monday").hide();
              $("#div_tuesday").hide();
              $("#div_wednesday").hide();
              $("#div_thursday").hide();
              $("#div_friday").hide();
              $("#div_saturday").hide();
              $("#div_sunday").hide();
              $("#div_exclude_holidays").hide();
              $("#label_monday").hide();
              $("#label_tuesday").hide();
              $("#label_wednesday").hide();
              $("#label_thursday").hide();
              $("#label_friday").hide();
              $("#label_saturday").hide();
              $("#label_sunday").hide();
              $("#label_exclude_holidays").hide();

          document.getElementById("fixed_date").disabled = false;
          document.getElementById("date_from").disabled = false;
          document.getElementById("date_to").disabled = false;
          document.getElementById("monday").disabled = true;
          document.getElementById("tuesday").disabled = true;
          document.getElementById("wednesday").disabled = true;
          document.getElementById("thursday").disabled = true;
          document.getElementById("friday").disabled = true;
          document.getElementById("saturday").disabled = true;
          document.getElementById("sunday").disabled = true;
          document.getElementById("exclude_holidays").disabled = true; 
        }
        
          this.detailData.check_repetition = $("#check_repetition").val();
    },*/


    delete(id) {
      var adminCrmConnections = this;
      var ln = adminCrmConnections.languages;
      spinnerHelpers.show();
      connectionsServices.del(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmConnections.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

      onNewConnections() {
      spinnerHelpers.show();
      var adminCrmConnections=this;
      this.rowIdSelected = 0;
      this.detailData = {};
      this.titleDetail = this.newCategories;

    /*  if (this.rowIdSelected == 0){
        $("#div-cont-options").hide();
      }else{
        $("#div-cont-options").show();
      }*/

      $("#fixed_date").val("");
      $("#date_from").val("");
      $("#date_to").val("");
      $("#schedule_date_time").val("");
      $("#start_time").val("");
      $("#end_time").val("");
      $("#description").val("");
      
      
      
      $('input[name="monday"]').prop('checked', false);
      $('input[name="tuesday"]').prop('checked', false);
      $('input[name="wednesday"]').prop('checked', false);
      $('input[name="thursday"]').prop('checked', false);
      $('input[name="friday"]').prop('checked', false);
      $('input[name="saturday"]').prop('checked', false);
      $('input[name="sunday"]').prop('checked', false);
      $('input[name="exclude_holidays"]').prop('checked', false);
      $('input[name="check_datefrom_and_dateto"]').prop('checked', false);
      $('input[name="check_fixed_date"]').prop('checked', false);
      $('input[name="check_repetition"]').prop('checked', false);

      $("#div_monday").hide();
      $("#div_tuesday").hide();
      $("#div_wednesday").hide();
      $("#div_thursday").hide();
      $("#div_friday").hide();
      $("#div_saturday").hide();
      $("#div_sunday").hide();
      $("#div_exclude_holidays").hide();
      $("#label_monday").hide();
      $("#label_tuesday").hide();
      $("#label_wednesday").hide();
      $("#label_thursday").hide();
      $("#label_friday").hide();
      $("#label_saturday").hide();
      $("#label_sunday").hide();
      $("#label_exclude_holidays").hide();
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      $("#btn-add-time").hide();
      spinnerHelpers.hide();
    },


    onTableCheckConnections() {
      var countRowSelected = this.$refs.tableConnections.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewConnections() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelConnections();
      }
    },

    executeCancelConnections() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
  
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    
       confirmAperturaViewDettaglioData() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeAperturaViewDettaglioData();
      }
    },

   /*   executeAperturaViewDettaglioData() {
         spinnerHelpers.show();
         var adminCrmConnections = this;

        if ( functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0 ) {
              this.detailData.id = this.rowIdSelected;

               var data = {
                connection_id: this.rowIdSelected,
                date_from: '2021-09-20'
              };

              connectionsServices.getByEventResultForParameter(data, function(result) {
           
              });
            }
    },*/


    confirmSaveNewConnections() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewConnections();
      }
    },

    executeSaveNewConnections() {
      //spinnerHelpers.show();
      var adminCrmConnections = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      var monday = false;
      var tuesday = false;
      var wednesday = false;
      var thursday = false;
      var friday = false;
      var saturday = false;
      var sunday = false;
      var exclude_holidays = false;

      if ($("#monday").is(":checked")) {
        monday = true;
      } else {
        monday = false;
      }
      if ($("#tuesday").is(":checked")) {
        tuesday = true;
      } else {
        tuesday = false;
      }
      if ($("#wednesday").is(":checked")) {
        wednesday = true;
      } else {
        wednesday = false;
      }
      if ($("#thursday").is(":checked")) {
        thursday = true;
      } else {
        thursday = false;
      }
      if ($("#friday").is(":checked")) {
        friday = true;
      } else {
        friday = false;
      }
       if ($("#saturday").is(":checked")) {
        saturday = true;
      } else {
        saturday = false;
      }
      if ($("#sunday").is(":checked")) {
        sunday = true;
      } else {
        sunday = false;
      }
      if ($("#exclude_holidays").is(":checked")) {
        exclude_holidays = true;
      } else {
        exclude_holidays = false;
      }
      
      this.detailData.monday = monday;
      this.detailData.tuesday = tuesday;
      this.detailData.wednesday = wednesday;
      this.detailData.thursday = thursday;
      this.detailData.friday = friday; 
      this.detailData.saturday = saturday;
      this.detailData.sunday = sunday;
      this.detailData.exclude_holidays = exclude_holidays;

      if ($("#check_fixed_date").is(":checked")) {
        this.detailData.check_fixed_date = 1;
      } else {
        this.detailData.check_fixed_date = '';
      }
      if ($("#check_datefrom_and_dateto").is(":checked")) {
        this.detailData.check_datefrom_and_dateto = 2;
      } else {
        this.detailData.check_datefrom_and_dateto = '';
      }

      if ($("#check_repetition").is(":checked")) {
        this.detailData.check_repetition = 3;
      } else {
        this.detailData.check_repetition = '';
      }

        this.detailData.fixed_date = $("#fixed_date").val();
        this.detailData.date_from = $("#date_from").val();
        this.detailData.date_to = $("#date_to").val();
        this.detailData.start_time = $("#start_time").val();
        this.detailData.end_time = $("#end_time").val();  
        this.detailData.start_time_pm = $("#start_time_pm").val();
        this.detailData.end_time_pm = $("#end_time_pm").val();  
        this.detailData.description = $("#description").val();
       
        var arrayOption = [];
        var jsonOption = {};
          
      for (var i = 0; i < 50; i++) {
        jsonOption = {};
        var check_each = false;
        if (functionHelpers.isValued($("#cost" + i).val())) {
          jsonOption["cost"] = $("#cost" + i).val();
        }
        if (functionHelpers.isValued($("#options" + i).val())) {
          jsonOption["options"] = $("#options" + i).val();
        }
         if (functionHelpers.isValued($("#optional_id" + i).val())) {
          jsonOption["optional_id"] = $("#optional_id" + i).val();
        }
        if ($("#check_each" + i).is(":checked")) {
          jsonOption["check_each"] = true;
        } else {
          jsonOption["check_each"] = false;
        }
        if (functionHelpers.isValued($("#optional_id" + i).val()) && functionHelpers.isValued($("#cost" + i).val())) {
          arrayOption.push(jsonOption);
        }
      }
      this.detailData.DetailOption = arrayOption;


    var arrayAddDayHour = [];
    var jsonAddDayHour = {}; 

    for (var j = 0; j < 10; j++) {
    jsonAddDayHour = {}; 
    var monday_agg = false;
    var tuesday_agg = false;
    var wednesday_agg = false;
    var thursday_agg = false;
    var friday_agg = false;
    var saturday_agg = false;
    var sunday_agg = false;
    var show_availability_calendar_agg = false;
    var exclude_holidays_agg = false;
    var limit_reservations = false;


    if ($("#monday_agg" + j).is(":checked")) {
          jsonAddDayHour["monday_agg"] = true;
        } else {
          jsonAddDayHour["monday_agg"] = false;
        }
     if ($("#tuesday_agg" + j).is(":checked")) {
          jsonAddDayHour["tuesday_agg"] = true;
        } else {
          jsonAddDayHour["tuesday_agg"] = false;
        }
      if ($("#wednesday_agg" + j).is(":checked")) {
          jsonAddDayHour["wednesday_agg"] = true;
        } else {
          jsonAddDayHour["wednesday_agg"] = false;
        }
      if ($("#thursday_agg" + j).is(":checked")) {
          jsonAddDayHour["thursday_agg"] = true;
        } else {
          jsonAddDayHour["thursday_agg"] = false;
        }
      if ($("#friday_agg" + j).is(":checked")) {
          jsonAddDayHour["friday_agg"] = true;
        } else {
          jsonAddDayHour["friday_agg"] = false;
        }
      if ($("#saturday_agg" + j).is(":checked")) {
          jsonAddDayHour["saturday_agg"] = true;
        } else {
          jsonAddDayHour["saturday_agg"] = false;
        }
      if ($("#sunday_agg" + j).is(":checked")) {
          jsonAddDayHour["sunday_agg"] = true;
        } else {
          jsonAddDayHour["sunday_agg"] = false;
        }
      if ($("#show_availability_calendar_agg" + j).is(":checked")) {
          jsonAddDayHour["show_availability_calendar_agg"] = true;
        } else {
          jsonAddDayHour["show_availability_calendar_agg"] = false;
        }
      if ($("#exclude_holidays_agg" + j).is(":checked")) {
          jsonAddDayHour["exclude_holidays_agg"] = true;
        } else {
          jsonAddDayHour["exclude_holidays_agg"] = false;
        }
           if ($("#limit_reservations" + j).is(":checked")) {
          jsonAddDayHour["limit_reservations"] = true;
        } else {
          jsonAddDayHour["limit_reservations"] = false;
        }
        
      if (functionHelpers.isValued($("#start_time_am_agg" + j).val())) {
          jsonAddDayHour["start_time_am_agg"] = $("#start_time_am_agg" + j).val();
        }
     
      if (functionHelpers.isValued($("#end_time_am_agg" + j).val())) {
          jsonAddDayHour["end_time_am_agg"] = $("#end_time_am_agg" + j).val();
      }
       if (functionHelpers.isValued($("#start_time_pm_agg" + j).val())) {
          jsonAddDayHour["start_time_pm_agg"] = $("#start_time_pm_agg" + j).val();
        }

      if (functionHelpers.isValued($("#end_time_pm_agg" + j).val())) {
          jsonAddDayHour["end_time_pm_agg"] = $("#end_time_pm_agg" + j).val();
      }
       if (functionHelpers.isValued($("#nr_place_agg" + j).val())) {
          jsonAddDayHour["nr_place_agg"] = $("#nr_place_agg" + j).val();
      }

       if (functionHelpers.isValued($("#hour" + j).val())) {
          jsonAddDayHour["hour"] = $("#hour" + j).val();
      }

          arrayAddDayHour.push(jsonAddDayHour);
      }

      this.detailData.DetailAddDayHour = arrayAddDayHour;

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.detailData.description)) {
        this.detailData.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }



    if ((this.detailData.check_datefrom_and_dateto == "" || this.detailData.check_datefrom_and_dateto == null || this.detailData.check_datefrom_and_dateto == 'null') &&
          (this.detailData.check_fixed_date == "" || this.detailData.check_fixed_date == null || this.detailData.check_fixed_date == 'null')) {       
          notificationHelpers.error("Attenzione,non puoi salvare, seleziona tra le due check opzioni: Data Fissa o Intervallo di date?");
    }else{
          if ( functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0 ) {
            this.detailData.id = this.rowIdSelected;
            connectionsServices.update(this.detailData, function(result) {
              adminCrmConnections.tableResult.push({
                id: result.data,
                success: true,
                message: adminCrmConnections.updateCompleted
              });
              notificationHelpers.success(adminCrmConnections.updateCompleted);
              adminCrmConnections.loadTable(adminCrmConnections.languages);
              $("#tabTable").addClass("active");
              $("#tabDetail").removeClass("active");
            });
          } else {
            connectionsServices.insert(this.detailData, function(result) {
              adminCrmConnections.tableResult.push({
                id: result.data,
                success: true,
                message: adminCrmConnections.insertCompleted
              });
              notificationHelpers.success(adminCrmConnections.insertCompleted);
              adminCrmConnections.loadTable(adminCrmConnections.languages);
              $("#tabTable").addClass("active");
              $("#tabDetail").removeClass("active");
            });
          }
    }

    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    }
  }

};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
    position: absolute;
    margin-top: 11px;
    z-index: 1;
}

.vue__time-picker input.display-time {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #5c6873;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    min-height: 56px;
    font-size: 16px;
}

.classinput {
    min-height: 56px;
    font-size: 15px;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    color: #5c6873;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
}

.form-controls {
  display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    color: #5c6873;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    min-height: 56px;
    font-size: 16px;
}

.labelclass {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px!important;
  padding: 0px 2px;
  margin: 0px 0px -2px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background: #FFFFFF;
  white-space: nowrap;
}
.labelclasss {
  white-space:nowrap;
}

.radio {
  margin-top: 20px;
}

</style>